// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as BlockInfo from "./blockInfo";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as Info$ReasonReactWebsite from "./Info.bs.js";
import * as Block$ReasonReactWebsite from "./Block.bs.js";

function getBlockInfo(prim) {
  return BlockInfo.getBlockInfo(prim);
}

function getBlockInfoPromise(hash, setter) {
  BlockInfo.getBlockInfo(hash).then(function (value) {
          Curry._1(setter, (function (param) {
                  return Caml_option.some(value);
                }));
          return Promise.resolve(Caml_option.some(value));
        }).catch(function (err) {
        console.log(err);
        return Promise.resolve(undefined);
      });
  
}

function PolkaBlock(Props) {
  var match = React.useState(function () {
        
      });
  var setInfo = match[1];
  var info = match[0];
  return React.createElement("div", {
              id: "content"
            }, React.createElement("div", {
                  id: "title"
                }, "Polkablock"), React.createElement("div", {
                  id: "search-inputs"
                }, React.createElement("input", {
                      id: "hash-input",
                      placeholder: "hash"
                    }), React.createElement("input", {
                      id: "number-input",
                      placeholder: "number"
                    })), React.createElement("div", {
                  id: "search-button",
                  onClick: (function (param) {
                      var hash = document.getElementById("hash-input").value;
                      var number = document.getElementById("number-input").value;
                      if (hash !== "") {
                        return getBlockInfoPromise({
                                    hash: hash,
                                    number: ""
                                  }, setInfo);
                      } else if (number !== "") {
                        return getBlockInfoPromise({
                                    hash: "",
                                    number: number
                                  }, setInfo);
                      } else {
                        return getBlockInfoPromise({
                                    hash: "",
                                    number: ""
                                  }, setInfo);
                      }
                    })
                }, "Search"), info !== undefined ? React.createElement(Block$ReasonReactWebsite.make, {
                    blockInfo: info
                  }) : React.createElement(Info$ReasonReactWebsite.make, {}));
}

var make = PolkaBlock;

export {
  getBlockInfo ,
  getBlockInfoPromise ,
  make ,
  
}
/* react Not a pure module */
